import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import { fetchProjectPropertyAnalysisPeriods } from 'jsx/components/manage/actions/project_property_analysis_periods';

import PropertyAnalysisPeriods from './PropertyAnalysisPeriods';
import FormBase from '../../../core/form/components/FormBase';

class PropertyAnalysisPeriodModal extends FormBase {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      isNew: false,
      title: 'Income',
    };

    this.onRefresh = this.onRefresh.bind(this);
  }

  async componentDidMount() {
    this.onRefresh()
  }

  componentDidUpdate() {
    const { id } = this.state;

    if (id !== this.props.id) {
      this.setState({id: this.props.id}, () => {
        this.onRefresh();
      });
    }
  }

  onRefresh() {
    this.props.dispatch(fetchProjectPropertyAnalysisPeriods({ property_id: this.props.id }));
  }

  render() {

    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        backdrop={false}
        fade={false}
        // size="xl"
        trapFocus={false}
        style={{maxWidth: '80%'}}
        // centered
      >

        <ModalBody>
          <PropertyAnalysisPeriods propertyId={this.state.id} onRefresh={this.onRefresh} />
        </ModalBody>

        <ModalFooter className="d-flex justify-content-center">
          <Button color="secondary" onClick={this.props.toggle} size="sm">
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
};

const mapStoreToProps = ({ attributes, enterprises }) => ({
  attributes,
  enterprises,
});

export default connect(mapStoreToProps)(PropertyAnalysisPeriodModal);

